// extracted by mini-css-extract-plugin
module.exports = {"todo-list":"TodoList_todo-list__2CKe8"};